import { RouteGuardProps } from 'modules/router'
import React, { Component } from 'react'
import { connect } from 'react-redux'

import * as fromAuthStore from '../auth/store'

type Props = OwnProps & RouteGuardProps

type OwnProps = {
  locale: string
}

type State = {
  loadedLocales: { [key: string]: boolean }
  activeLang: string
}

const LocalesMapper: { [key: string]: string } = {
  'cs-CZ': 'cs',
  'en-US': 'en',
  'ru-RU': 'en',
  'zh-CN': 'en',
}

const mapStateToProps = (state: fromAuthStore.AuthState) => ({
  locale: fromAuthStore.getLocaleString(state),
})

const enhance = connect(mapStateToProps)

export class DateFnsProvider extends Component<Props, State> {
  state: State = {
    loadedLocales: {},
    activeLang: '',
  }

  render() {
    const { locale, children } = this.props
    const { loadedLocales } = this.state
    const hasLocale = loadedLocales[LocalesMapper[locale]]

    return hasLocale ? children : <span>Loading Locales date-fns...</span>
  }

  componentDidMount() {
    this.handleLocaleInitialization()
  }
  componentDidUpdate() {
    this.handleLocaleInitialization()
  }

  handleLocaleInitialization() {
    const { locale: localeId } = this.props

    if (!localeId) {
      return
    }

    this.loadLocale(LocalesMapper[localeId])
  }

  loadLocale(localeId: string) {
    const { loadedLocales } = this.state

    return loadedLocales[localeId]
      ? this.setGlobalLocale(localeId)
      : import(`date-fns/locale/${localeId}`).then((result) => {
          // tslint:disable-next-line:no-string-literal
          Object.assign(window, { __LocaleSettings: { ...(window as any)['__LocaleSettings'], locale: result } })

          this.setState((prev) => ({
            loadedLocales: {
              ...prev.loadedLocales,
              [localeId]: true,
            },
          }))
        })
  }

  setGlobalLocale(localeId: string) {
    const { activeLang } = this.state

    if (activeLang !== LocalesMapper[localeId]) {
      this.setState((prev) => ({ ...prev, activeLang: LocalesMapper[localeId] }))
    }
  }
}

export default enhance(DateFnsProvider)



// WEBPACK FOOTER //
// ./src/app/core/date-fns.provider.tsx